import React from 'react';
import { toast, Slide } from 'react-toastify';
import Notification from '../components/Notification';

const showNotification = ({ type = 'info', messages }) => {
  toast(<Notification type={type} messages={messages} />, {
    position: 'top-center',
    transition: Slide,
    closeOnClick: false,
    type,
    className: `notifications ${type}`,
    closeButton: false,
    progressClassName: 'custom-progress-bar',
  });
};

export default showNotification;
